// this rule was flagging errors even after they had been fixed
/* eslint-disable jsx-a11y/label-has-for */
// underscore dangle unavoidable due to implementation detail of React Table library
/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MakeSchedule.css';
import moment from 'moment';
import checkboxHOC from 'react-table/lib/hoc/selectTable';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { t } from 'i18next';
import TensorFilter from '../tensorFilter/filters/TensorFilter';
import {
  retrieveModels, createSchedule, updateScheduleBatch, getOEMDevices,
} from '../../services/testResultsService';
import Loading from '../../../loading/Loading';


const SelectTable = checkboxHOC(ReactTable);

class MakeSchedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      batchParams: {
        createDate: '',
        dayOfMonth: [],
        dayOfWeek: [],
        devices: [],
        deviceType: [],
        endDate: moment('2018-08-03'),
        frequency: 'Immediate',
        jobname: '',
        jobStatus: 'Ready',
        modelName: '',
        modelPlotType: [],
        normalization: 'pctdiff',
        oemId: '',
        scheduleDate: moment(),
        startDate: moment('2018-08-01'),
        threshold: '75',
        timeOfDay: moment(),
        versionId: '',
      },
      latestModelVersion: {
        modelName: '',
        modelPlotType: '',
        oemId: '',
        versionId: '',
      },
      selectAll: false,
      selection: [],


    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.scaleTime = this.scaleTime.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleScheduleDateChange = this.handleScheduleDateChange.bind(this);
    this.scheduleBatch = this.scheduleBatch.bind(this);
    this.updateBatch = this.updateBatch.bind(this);
    this.getDSNs = this.getDSNs.bind(this);

    this.selectTable = React.createRef();
  }

  componentDidMount() {
    const { batchParams } = this.state;
    const { scheduleInfo } = this.props;
    const batch = {
      ...batchParams,
    };
    if (scheduleInfo) {
      this.handleUpdateSelection();
    } else {
      this.getModelInfo();
      const date = new Date();
      const utcDate = date.toISOString();
      batch.createDate = utcDate;
      this.setState({
        batchParams: batch,
      });
    }
  }

  getDSNs(deviceModel, softwareVersion) {
    this.setState({
      loading: true
    });
    getOEMDevices(deviceModel, softwareVersion).then(response => {
      const {
        devices,
        // next_page, previous_page, end_count_on_page, start_count_on_page, total, current_page_number,
      } = response;

      this.setState({
        // devices,
        loading: false,
        // response.current_page_number
      }, () => this.createDevicesObject(devices));
    });
  }

  getModelInfo() {
    retrieveModels().then((data) => {
      const { updateJob } = this.props;
      const { batchParams } = this.state;
      let modelName;
      if (! updateJob && data.body.Items) {
        const versionId = data.body.Items[0].VersionID;
        modelName = data.body.Items[0].trainModelName;
        const batch = {
          ...batchParams,
        };
        batch.modelName = modelName;
        batch.versionId = versionId;
        this.setState({
          batchParams: batch,
        });
      }
      this.fillModelInfo(modelName);
    });
  }

    toggleSelection = (key) => {
      const { selection } = this.state;
      let newSelection = [...selection];
      const newKey = key.slice(7, key.length);
      const keyIndex = selection.indexOf(newKey);
      if (keyIndex >= 0) {
        newSelection = [
          ...newSelection.slice(0, keyIndex),
          ...newSelection.slice(keyIndex + 1),
        ];
      } else {
        newSelection.push(newKey);
      }
      this.setState({
        selection: newSelection,
      });
    };

    isSelected = (key) => {
      const { selection } = this.state;
      return selection.includes(key);
    };

    toggleAll = () => {
      let { selectAll } = this.state;
      selectAll = ! selectAll;
      const selection = [];
      if (selectAll) {
        const wrappedInstance = this.selectTable.current.getWrappedInstance();
        const currentRecords = wrappedInstance.getResolvedState().sortedData;
        currentRecords.forEach(item => selection.push(item._original.deviceID));
      }
      this.setState({
        selectAll,
        selection,
      });
    };

    // change handlers
    handleInputChange = (e) => {
      e.preventDefault();
      const { batchParams } = this.state;
      const element = e.target;
      let newVal = element.value;
      const id = element.name;
      const batch = {
        ...batchParams,
      };
      if (id === 'jobname') newVal = newVal.replace(/[^a-zA-Z0-9]/g, '');
      if (newVal === 'Daily') {
        batch.dayOfMonth = [];
        batch.dayOfWeek = [];
        batch.scheduleDate = [];
        batch.timeOfDay = moment();
      } else if (newVal === 'Weekly') {
        batch.dayOfMonth = [];
        batch.dayOfWeek = 'Monday';
        batch.scheduleDate = [];
        batch.timeOfDay = moment();
      } else if (newVal === 'Monthly') {
        batch.dayOfMonth = '1';
        batch.dayOfWeek = [];
        batch.scheduleDate = [];
        batch.timeOfDay = moment();
      } else if (newVal === 'Immediate') {
        batch.dayOfMonth = [];
        batch.dayOfWeek = [];
        batch.scheduleDate = [];
        batch.timeOfDay = [];
      } else if (newVal === 'Once') {
        batch.dayOfMonth = [];
        batch.dayOfWeek = [];
        batch.scheduleDate = moment();
        batch.timeOfDay = moment();
      }

      batch[id] = newVal;
      this.setState({
        batchParams: batch,
      });
    }

    fillModelInfo = (modelName) => {
      const { batchParams } = this.state;
      const { filteredModels } = this.props;
      const batch = {
        ...batchParams,
      };
      let modelArray;
      let modelInfo;
      let lastNumber;
      let latestVersion;
      if (modelName) {
        modelArray = filteredModels;
        modelInfo = modelArray[modelName];
        lastNumber = modelInfo.length - 1;
        latestVersion = modelInfo[lastNumber];
        batch.modelName = modelName;
        this.setState({
          batchParams: batch,
          latestModelVersion: latestVersion,
        }, () => this.getDSNs(latestVersion.DeviceModelType, latestVersion.SoftwareVersion));
      }
    }

    handleModelSelect = (e) => {
      const modelName = e.target.value;
      this.fillModelInfo(modelName);
    }

    updateBatch() {
      const { batchParams } = this.state;
      const { closeModal, retrieveSchedules } = this.props;
      const batch = {
        ...batchParams,
      };
      updateScheduleBatch(batch).then(() => {
        retrieveSchedules();
        setTimeout(closeModal, 1000);
      });
    }

    createDevicesObject(deviceList) {
      const deviceContainer = deviceList.map((device) => ({
        alias: device.device.product_name,
        connection_status: device.device.connection_status,
        deviceID: device.device.dsn,
      }));

      this.setState({
        deviceContainer,
        loading: false
      });
    }

    // services
    scheduleBatch() {
      const {
        selection, batchParams, latestModelVersion,
      } = this.state;
      const { closeModal, reloadSchedules } = this.props;
      const newJob = {
        ...batchParams,
      };
      const start = newJob.startDate;
      const end = newJob.endDate;
      const time = newJob.timeOfDay;
      const s = moment.utc(start).startOf('day');
      const e = moment.utc(end).startOf('day');
      const ti = moment.utc(time);
      const timeOfDay = ti.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
      const startDate = s.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
      const endDate = e.format('YYYYMMDD[T]HH:mm:ss.SSS[Z]');
      newJob.startDate = startDate;
      newJob.endDate = endDate;
      newJob.timeOfDay = timeOfDay;

      const version = {
        ...latestModelVersion,
      };
      const versionNumber = version.VersionID;
      newJob.modelPlotType = version.ModelType;
      newJob.versionId = versionNumber.toString();
      newJob.devices = selection;
      newJob.oemId = version.OemID;
      newJob.deviceType = version.DeviceModelType;
      newJob.softwareVersion = version.SoftwareVersion;
      //   This Lambda requires no serialized json
      createSchedule(newJob).then(() => { reloadSchedules(); });
      setTimeout(closeModal, 1000);
    }

    handleUpdateSelection() {
      const { scheduleInfo } = this.props;
      const { batchParams } = this.state;
      const batch = {
        ...batchParams,
      };
      const date = new Date();
      const utcDate = date.toISOString();
      batch.createDate = utcDate;
      const versionNumber = scheduleInfo.VersionID;
      batch.versionId = versionNumber.toString();
      batch.jobname = scheduleInfo.JobName;
      batch.modelName = scheduleInfo.ModelName;
      batch.devices = scheduleInfo.Devices;
      batch.frequency = scheduleInfo.Frequency;
      batch.jobStatus = scheduleInfo.JobStatus;
      batch.modelPlotType = scheduleInfo.ModelPlotType;
      batch.oemId = scheduleInfo.OemID;
      batch.dayOfMonth = scheduleInfo.StartDayMonth;
      batch.dayOfWeek = scheduleInfo.StartDay;

      this.setState({
        batchParams: batch,
      });
    }

    handleTimeChange(time) {
      const { batchParams } = this.state;
      const batch = {
        ...batchParams,
      };
      batch.timeOfDay = time;
      this.setState({
        batchParams: batch,
      });
    }

    handleScheduleDateChange(date) {
      const { batchParams } = this.state;
      const batch = {
        ...batchParams,
      };
      batch.scheduleDate = date;

      this.setState({
        batchParams: batch,
      });
    }

    handleChangeStart(date) {
      const { batchParams } = this.state;
      const batch = {
        ...batchParams,
      };
      batch.startDate = date;
      this.setState({
        batchParams: batch,
      });
    }

    handleChangeEnd(date) {
      const { batchParams } = this.state;
      const batch = {
        ...batchParams,
      };
      batch.endDate = date;
      this.setState({
        batchParams: batch,
      });
    }

    scaleTime(interval) {
      const days = [];
      for (let i = 1; i < 31; i += 1) {
        days.push(i);
      }
      const dayOptions = days.map(day => (
        <option value={day}
          key={day}
        >
          {day}
        </option>
      ));
      return (() => {
        const { batchParams } = this.state;
        switch (interval) {
          default:
          case 'Daily':
            return (
              <div className="selection daily-selection">
                <label htmlFor="scheduleSelectTimeOfDay">
                  <em>
                    {`${t('tensorAnalytics.makeScheduleComponent.selectTimeOfDay')}:`}
                  </em>
                </label>
                <DatePicker selected={batchParams.timeOfDay}
                  onChange={this.handleTimeChange}
                  showTimeSelect
                  showTimeSelectOnly
                  shouldCloseOnSelect
                  timeIntervals={15}
                  dateFormat="h:mm A"
                  timeCaption={t('tensorAnalytics.makeScheduleComponent.timeCaption')}
                />
              </div>
            );
          case 'Weekly':
            return (
              <div className="selection">
                <label className="weekly-selection"
                  htmlFor="dayOfWeek"
                >
                  <em>
                    {`${t('tensorAnalytics.makeScheduleComponent.dayOfEachWeek')}:`}
                  </em>
                  <select value={batchParams.dayOfWeek}
                    onChange={this.handleInputChange}
                    name="dayOfWeek"
                  >
                    <option value="Monday">{t('tensorAnalytics.common.monday')}</option>
                    <option value="Tuesday">{t('tensorAnalytics.common.tuesday')}</option>
                    <option value="Wednesday">{t('tensorAnalytics.common.wednesday')}</option>
                    <option value="Thursday">{t('tensorAnalytics.common.thursday')}</option>
                    <option value="Friday">{t('tensorAnalytics.common.friday')}</option>
                    <option value="Saturday">{t('tensorAnalytics.common.saturday')}</option>
                    <option value="Sunday">{t('tensorAnalytics.common.sunday')}</option>
                  </select>
                  <label htmlFor="selectTimeOfDay">
                    <em>
                      {`${t('tensorAnalytics.makeScheduleComponent.selectTimeOfDay')}:`}
                    </em>
                    <DatePicker selected={batchParams.timeOfDay}
                      onChange={this.handleTimeChange}
                      name="time"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      dateFormat="h:mm A"
                      timeCaption={t('tensorAnalytics.makeScheduleComponent.timeCaption')}
                    />
                  </label>
                </label>
              </div>
            );
          case 'Monthly':
            return (
              <div className="selection">
                <label className="monthly-selection"
                  htmlFor="selectDayOfMonth"
                >
                  <em>
                    {`${t('tensorAnalytics.makeScheduleComponent.selectDayOfEachMonth')}:`}
                  </em>
                  <select onChange={this.handleInputChange}
                    name="dayOfMonth"
                  >
                    {dayOptions}
                  </select>
                  <label htmlFor="selectTimeOfDay">
                    <em>
                      {`${t('tensorAnalytics.makeScheduleComponent.selectTimeOfDay')}:`}
                    </em>
                    <DatePicker selected={batchParams.timeOfDay}
                      onChange={this.handleTimeChange}
                      name="time"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      dateFormat="h:mm A"
                      timeCaption={t('tensorAnalytics.makeScheduleComponent.timeCaption')}
                    />
                  </label>
                </label>
              </div>
            );
          case 'Once':
            return (
              <div className="selection">
                <label htmlFor="selectOnceLabel">
                  <em>{t('tensorAnalytics.makeScheduleComponent.selectOnceLabel')}</em>
                  <div>
                    <DatePicker selected={batchParams.scheduleDate}
                      onChange={this.handleScheduleDateChange}
                    />
                  </div>
                  <div className="single-selection">
                    <DatePicker selected={batchParams.timeOfDay}
                      onChange={this.handleTimeChange}
                      name="time"
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      dateFormat="h:mm A"
                      timeCaption={t('tensorAnalytics.makeScheduleComponent.timeCaption')}
                    />
                  </div>
                </label>
              </div>
            );
          case 'Immediate':
            return (
              <div className="selection" />
            );
        }
      });
    }

    render() {
      const {
        selectAll, batchParams, deviceContainer, latestModelVersion, loading
      } = this.state;
      const {
        filteredModels, updateJob, scheduleInfo,
      } = this.props;
      const {
        toggleSelection, toggleAll, isSelected,
      } = this;
      const data = deviceContainer;

      const columns = [{
        accessor: 'deviceID',
        Header: t('tensorAnalytics.tableHeaders.deviceID'),
      },
      {
        accessor: 'connection_status',
        Header: t('tensorAnalytics.tableHeaders.connection_status'),
      }, {
        accessor: d => d.alias, // Custom value accessor example
        Header: t('tensorAnalytics.tableHeaders.alias'),
        id: 'alias', // Required because our accessor is not a string
      }];
      const checkboxProps = {
        getTrProps: (s, r) => {
          const selected = r ? this.isSelected(r.original.deviceID) : '';
          return {
            style: {
              border: selected ? '1px solid' : 'initial',
              borderColor: selected ? '#669044' : 'initial',
              borderRadius: '5px',
            },
          };
        },
        isSelected,
        selectAll,
        selectType: 'checkbox',
        toggleAll,
        toggleSelection,
      };

      let convertModels;
      if (filteredModels) {
        convertModels = Object.entries(filteredModels)
          .filter(model => model[1][0].trainStatus === 'Completed')
          .map(model => <option key={model[0]}>{model[0]}</option>);
      }

      return (
        <div className={updateJob ? 'make-schedule update-job' : 'make-schedule create-job'}>
          <TensorFilter handleChangeStart={this.handleChangeStart}
            makeSchedule="true"
            handleChangeEnd={this.handleChangeEnd}
            selectedStart={batchParams.startDate}
            selectedEnd={batchParams.endDate}
            oemModel={latestModelVersion.DeviceModelType}
            softwareVersion={latestModelVersion.SoftwareVersion}
            schedulesPage
          />
          <form autoComplete="off"
            className="anomParams create-update-form"
          >
            <div className="left-column">
              <div className={updateJob ? 'hide' : 'show'}>
                <div className="jobname-container">
                  <label htmlFor="jobname">
                    {`${t('tensorAnalytics.makeScheduleComponent.jobName')}: `}
                  </label>
                  <input value={batchParams.jobname}
                    maxLength={30}
                    className={batchParams.jobname.length === 0 ? 'error' : ''}
                    type="text"
                    name="jobname"
                    id="jobname"
                    placeholder={t('tensorAnalytics.makeScheduleComponent.jobNamePlaceHolder')}
                    onChange={this.handleInputChange}
                  />
                </div>
                <div className="select-model">
                  <label htmlFor="modelName">
                    {`${t('tensorAnalytics.makeScheduleComponent.selectModel')}: `}
                    <br />
                    <select value={batchParams.modelName}
                      name="modelName"
                      id="modelName"
                      onChange={this.handleModelSelect}
                    >
                      <option value=""
                        disabled
                      >
                        {t('tensorAnalytics.makeScheduleComponent.chooseHere')}
                      </option>
                      {convertModels}
                    </select>
                    <em className="em-description">
                      {t('tensorAnalytics.makeScheduleComponent.selectModelDescription')}
                    </em>
                  </label>
                </div>
              </div>
              <div className={updateJob ? 'show' : 'hide'}>
                <div>
                  <h6>
                    {`${t('tensorAnalytics.makeScheduleComponent.jobName')}: `}
                    {scheduleInfo ? scheduleInfo.JobName : ''}
                  </h6>
                </div>
                <div>
                  <h6>
                    {`${t('tensorAnalytics.commonTerms.OEMID')}: `}
                    {scheduleInfo ? scheduleInfo.OemID : ''}
                  </h6>
                </div>
                <div>
                  <h6>
                    {`${t('tensorAnalytics.commonTerms.modelName')}: `}
                    {scheduleInfo ? scheduleInfo.ModelName : ''}
                  </h6>
                </div>
                <div>
                  <h6>
                    {`${t('tensorAnalytics.commonTerms.versionNumber')}: `}
                    {scheduleInfo ? scheduleInfo.VersionID : ''}
                  </h6>
                </div>
              </div>
              <div className={updateJob ? 'hide' : 'show latest-version-info'}>
                <div>
                  <label htmlFor="modelVersionNumber">
                    {`${t('tensorAnalytics.commonTerms.modelVersionNumber')}: `}
                    {latestModelVersion.VersionID}
                  </label>
                </div>
              </div>
            </div>
            <hr className="separation-line"
              width="1"
              height="300"
            />
            <div className="middle-column">
              <div className="frequency-selection">
                <label htmlFor="frequency">
                  {`${t('tensorAnalytics.makeScheduleComponent.selectFrequency')}: `}
                  <select value={batchParams.frequency}
                    name="frequency"
                    id="frequency"
                    onChange={this.handleInputChange}
                  >
                    <option value="Immediate">{t('tensorAnalytics.common.immediately')}</option>
                    <option value="Once">{t('tensorAnalytics.common.once')}</option>
                    <option value="Daily">{t('tensorAnalytics.common.daily')}</option>
                    <option value="Weekly">{t('tensorAnalytics.common.weekly')}</option>
                    <option value="Monthly">{t('tensorAnalytics.common.monthly')}</option>
                  </select>
                </label>
              </div>
              <div className="scale-time-container">
                {this.scaleTime(batchParams.frequency)()}
              </div>
            </div>
            <hr className="separation-line"
              width="1"
              height="300"
            />
            <div className="right-column">
              <div className="normalization-select">
                <label htmlFor="normalization">
                  {'Select Normalization Preference'}
                </label>
                <select name="normalization"
                  id="normalization"
                  value={batchParams.normalization}
                  onChange={this.handleInputChange}
                >
                  <option value="pctdiff">Percent Difference</option>
                  <option value="minmax">Min-Max</option>
                  <option value="diff">Difference</option>
                </select>
              </div>
              <div className="threshold">
                <label htmlFor="threshold">
                  {'Select Threshold'}
                </label>
                <input type="number"
                  name="threshold"
                  id="threshold"
                  value={batchParams.threshold}
                  onChange={this.handleInputChange}
                />
              </div>
            </div>

          </form>
          <div className={updateJob ? 'hide' : 'show grid-container'}>
            <SelectTable data={data}
              className="-striped -highlight"
              columns={columns}
              filterable
              {...checkboxProps}
              keyField="deviceID"
              resizable={false}
              loading={loading}
              loadingText={<Loading size={40} />}
              noDataText="No devices found"
              style={{
                height: '500px',
              }}
              ref={this.selectTable}
            />
          </div>
          <button type="button"
            className={! updateJob ? 'show submit-batch-btn' : 'hide'}
            onClick={this.scheduleBatch}
            disabled={batchParams.jobname.length === 0}
          >
            {t('tensorAnalytics.makeScheduleComponent.scheduleAnomalyDetection')}
          </button>
          <button type="button"
            className={updateJob ? 'show submit-batch-btn' : 'hide'}
            onClick={this.updateBatch}
          >
            {t('tensorAnalytics.makeScheduleComponent.updateDetectionSchedule')}
          </button>
        </div>
      );
    }
}

export default MakeSchedule;
